export default __webpack_public_path__ + "static/media/documents.1b420e8e.svg";